import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import AppShell from '../components/layout/AppShell';
import useDocumentTitle from '../hooks/useDocumentTitle';
import api from '../utils/axiosConfig';
import '../styles/ContactPage.css';

function ContactPage() {
  const navigate = useNavigate();
  useDocumentTitle('تواصل معنا');

  const [type, setType] = useState('issue');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!message.trim() || message.trim().length < 5) {
      return toast.error('يرجى كتابة تفاصيل أوضح');
    }
    setSubmitting(true);
    try {
      const { data } = await api.post('/contact', {
        type,
        name: name.trim(),
        phone: phone.trim(),
        email: email.trim(),
        message: message.trim(),
      });
      if (data.success) {
        toast.success(data.message);
        setMessage('');
      } else {
        toast.error(data.message || 'حدث خطأ');
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'تعذر إرسال الرسالة');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AppShell>
      <div className="contact-container">
        <button className="contact-back-btn" type="button" onClick={() => navigate(-1)}>
          ← رجوع
        </button>

        <div className="contact-card">
          <div className="contact-icon">✉️</div>
          <h1 className="contact-title">تواصل معنا</h1>
          <p className="contact-subtitle">
            للإبلاغ عن مشكلة أو اقتراح ميزة جديدة. تصل رسالتك مباشرة إلى فريق أدواري.
          </p>

          <form className="contact-form" onSubmit={handleSubmit}>
            <label htmlFor="contact-type">نوع الرسالة</label>
            <select
              id="contact-type"
              value={type}
              onChange={(e) => setType(e.target.value)}
            >
              <option value="issue">مشكلة / استفسار</option>
              <option value="feature">طلب ميزة جديدة</option>
            </select>

            <label htmlFor="contact-name">الاسم (اختياري)</label>
            <input
              id="contact-name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="اسمك"
            />

            <label htmlFor="contact-phone">الهاتف (اختياري)</label>
            <input
              id="contact-phone"
              type="tel"
              dir="ltr"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="+972..."
            />

            <label htmlFor="contact-email">البريد (اختياري)</label>
            <input
              id="contact-email"
              type="email"
              dir="ltr"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
            />

            <label htmlFor="contact-message">الرسالة</label>
            <textarea
              id="contact-message"
              rows={6}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="اكتب تفاصيل المشكلة أو الميزة المطلوبة..."
              required
            />

            <button type="submit" className="contact-submit" disabled={submitting}>
              {submitting ? 'جاري الإرسال...' : 'إرسال الرسالة'}
            </button>
          </form>
        </div>
      </div>
    </AppShell>
  );
}

export default ContactPage;
